import React from 'react';
import ReportingMembershipsFailedPaymentsPage from '../components/ReportingMembershipsFailedPaymentsPage';

const ReportingMembershipsFailedPaymentsApp = (props) => (
  <ReportingMembershipsFailedPaymentsPage {...props} />
);

export default ReportingMembershipsFailedPaymentsApp;
